/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url, react/no-unused-prop-types */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
  withFilterCategory,
  CHANNEL_ALL_RECOMMENDATIONS,
  CHANNEL_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import {
  getPreferences,
  PREFERENCES_ACTION_TYPES,
} from '@bingads-webui-campaign/recommendation-preferences';
import { withUserGovernance } from '@bingads-webui-campaign-react/popup-components';
import { TeachingBubbleWithLock } from './teaching-bubble';

class optimizationScoreTeachingBubble extends React.Component {
  static propTypes = {
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
    currentActivity: PropTypes.shape({
      trace: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
    }).isRequired,
    overallOptimizationScoreBar: PropTypes.shape({
      Available: PropTypes.number,
    }),
    categoryScoreUpLifts: PropTypes.arrayOf(PropTypes.shape({
      Category: PropTypes.string,
      ScoreUpLift: PropTypes.number,
    })),
    type: PropTypes.string,
    data: PropTypes.shape(_.reduce(
      CHANNEL_ALL_RECOMMENDATIONS[CHANNEL_TYPES.RECOMMENDATION],
      recommendation => ({
        [recommendation]: PropTypes.object,
      }),
      {}
    )),
    onDone: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
  };

  static defaultProps = {
    overallOptimizationScoreBar: null,
    categoryScoreUpLifts: [],
    type: null,
    data: [],
  };

  state = {
    step: 0,
  };

  next = () => {
    this.setState({ step: this.state.step + 1 });
  }

  previous = () => {
    this.setState({ step: this.state.step - 1 });
  }

  isOnBoard() {
    return !_.result(
      getPreferences(this.props.preferencesService),
      PREFERENCES_ACTION_TYPES.OptimizationScoreOnboard
    );
  }

  render() {
    const {
      i18n,
      overallOptimizationScoreBar,
      categoryScoreUpLifts,
      type,
      data,
      onDone,
      onDismiss,
      onClose,
    } = this.props;

    const hasOptimizationScore = !_.isNull(overallOptimizationScoreBar)
      && !_.isUndefined(overallOptimizationScoreBar.Available);
    const anyCategoryOptimizationScore = !_.isEmpty(categoryScoreUpLifts);
    const anySummaryCardOptimizationScore =
      _.isNull(type) || _.isEmpty(type)
        ? _.any(_.map(data, typeLevelRecommendation =>
          !_.isNull(typeLevelRecommendation.optimizationScore)))
        : data[type] && !_.isNull(data[type].optimizationScore);

    let stepCount = 0;
    if (hasOptimizationScore) {
      if (anyCategoryOptimizationScore) {
        if (anySummaryCardOptimizationScore) {
          stepCount = 3;
        } else {
          stepCount = 2;
        }
      } else {
        stepCount = 1;
      }
    }

    const titles = [
      i18n.getString(_TL_('Optimization score: How well you\'re set up to get the most from your account or campaign.')),
      i18n.getString(_TL_('Understanding score uplifts')),
      i18n.getString(_TL_('Boost your optimization score by applying individual recommendations')),
    ];

    const contents = [
      (
        <div>
          <div className="first-paragraph">
            {i18n.getString(_TL_('Your optimization score runs from 0% to 100%, with 100% meaning that your account or campaign can function at its full potential.'))}
          </div>
          <div className="second-paragraph">
            {i18n.getString(_TL_('Optimization score is only shown for active search campaigns at the campaign and account level.'))}
          </div>
        </div>
      ),
      i18n.getString(_TL_('This is the uplift to your optimization score if you adopt the recommendations in this category.')),
      i18n.getString(_TL_('Individual recommendations also have their own score uplift. Apply recommendations whenever you can to improve campaign performance!')),
    ];

    const targets = [
      '.overall-score-value',
      '.category-score-upLift',
      '.summary-card-os-tag-container',
    ];

    return stepCount > 0 && this.isOnBoard() && (
      <div className="optimization-score-teaching-bubble">
        {
          _.map(_.range(stepCount), step =>
            this.state.step === step && (
              <TeachingBubbleWithLock
                name="optimization-score-teaching-bubble"
                i18n={i18n}
                title={titles[step]}
                pageIndex={step + 1}
                pageCount={stepCount}
                primaryButtonContent={
                  stepCount > step + 1
                  ? i18n.getString(_TL_('Next'))
                  : i18n.getString(_TL_('Got it!'))
                }
                primaryButtonAction={
                  stepCount > step + 1
                  ? this.next
                  : () => onDone()
                }
                secondaryButtonContent={
                  step === 0
                  ? ''
                  : i18n.getString(_TL_('Previous'))
                }
                secondaryButtonAction={this.previous}
                target={targets[step]}
                onDismiss={onDismiss}
                onClose={onClose}
              >
                {contents[step]}
              </TeachingBubbleWithLock>
            ))
        }
      </div>
    );
  }
}

export const OptimizationScoreTeachingBubble =
  withFilterCategory(optimizationScoreTeachingBubble);


export const OptimizationScoreTeachingBubbleWithUserGovernance = withUserGovernance(OptimizationScoreTeachingBubble);
